export const StatusCircleThreeQuarterIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="11"
      height="11"
      rx="5.5"
      stroke="currentColor"
    />
    <path
      d="M2 6C2 6.79112 2.2346 7.56448 2.67412 8.22228C3.11365 8.88008 3.73836 9.39277 4.46927 9.69552C5.20017 9.99827 6.00444 10.0775 6.78036 9.92314C7.55628 9.7688 8.26902 9.38784 8.82843 8.82843C9.38784 8.26902 9.7688 7.55629 9.92314 6.78036C10.0775 6.00444 9.99827 5.20017 9.69552 4.46927C9.39277 3.73836 8.88008 3.11365 8.22228 2.67412C7.56448 2.2346 6.79113 2 6 2L6 6L2 6Z"
      fill="currentColor"
    />
  </svg>
);
